// Predefined permission constants
export const PERMISSIONS = {
  // Settings page permissions
  SETTINGS_SMART_ROUTING: 'settings:smart_routing',
  SETTINGS_SKIP_AUTH: 'settings:skip_auth',
  SETTINGS_INSTALL_CONFIG: 'settings:install_config',
  SETTINGS_EXPORT_CONFIG: 'settings:export_config',
} as const;

export default PERMISSIONS;
